import { render, staticRenderFns } from "./TitleContainer.vue?vue&type=template&id=596636e0&scoped=true&"
import script from "./TitleContainer.vue?vue&type=script&lang=js&"
export * from "./TitleContainer.vue?vue&type=script&lang=js&"
import style0 from "./TitleContainer.vue?vue&type=style&index=0&id=596636e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596636e0",
  null
  
)

export default component.exports